<template>
  <footer id="footer" class="py-4 bg-black text-white">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-4 text-center text-md-left mb-3 mb-md-0">
          <img src="../assets/images/logo_2.png" height="50" alt="Sankoree Logo" />
        </div>
        
        <div class="col-md-8">
          <ul class="list-inline mb-0 text-center text-md-right lora footer-links">
            <li class="list-inline-item mr-4"><router-link to="/">Home</router-link></li>
            <li class="list-inline-item mr-4"><a href="#about">About</a></li>
            <li class="list-inline-item mr-4"><a href="#theInstitute">The Institute</a></li>
            <li class="list-inline-item"><router-link to="/SIGN/DC/2026" class="text-accent font-weight-bold">SIGN DC 2026</router-link></li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter"
};
</script>

<style scoped>
#footer {
  background-color: #050505 !important;
  border-top: 1px solid rgba(196, 5, 5, 0.2);
}

.text-accent {
  color: #c40505;
}

.bg-black {
  background-color: #000 !important;
}

.outfit {
  font-family: 'Outfit', sans-serif;
}

.lora {
  font-family: 'Lora', serif;
}

.uppercase {
  text-transform: uppercase;
}

.tracking-widest {
  letter-spacing: 2px;
  font-size: 0.85rem;
}

.footer-links li {
  margin-bottom: 12px;
}

.footer-links a {
  color: #888;
  text-decoration: none;
  transition: all 0.3s ease;
}

.footer-links a:hover {
  color: #c40505;
  padding-left: 5px;
}

.hover-white:hover {
  color: white !important;
}

.border-secondary {
  border-color: rgba(255, 255, 255, 0.1) !important;
}

@media (max-width: 991.98px) {
  #footer {
    text-align: center;
  }
  
  #footer ul {
    margin-bottom: 30px;
  }
  
  .footer-links a:hover {
    padding-left: 0;
  }
  
  .pr-lg-5 {
    padding-right: 0 !important;
  }
}
</style>